import {MoneyV2} from '@shopify/hydrogen/storefront-api-types';
import {useMoney} from '@shopify/hydrogen';
import clsx from 'clsx';
import {Text} from '~/components';
import React from 'react';
import {DATA_TEST_IDS} from '~/lib/const';

export function CompareAtPrice({
  data,
  className,
  prefix,
}: {
  data: MoneyV2;
  className?: string;
  prefix?: string;
}) {
  const {currencyNarrowSymbol, withoutTrailingZerosAndCurrency} =
    useMoney(data);

  const styles = clsx('strike', className);

  return (
    <Text as={'h6'} className={styles} testid={DATA_TEST_IDS.COMPARE_AT_PRICE}>
      {prefix}
      {currencyNarrowSymbol}
      {withoutTrailingZerosAndCurrency}
    </Text>
  );
}
